<template>
  <div
    v-show="display"
    @click="$emit('click')"
    class="close-icon position-absolute right-0 text-danger"
  >
    <font-awesome-icon icon="x" size="xs" />
  </div>
</template>
<script>
export default {
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">
.close-icon {
  cursor: pointer;
  right: 28px;
  top: 50%;
  font-size: 0.875rem;
  transform: translateY(-50%);
}
</style>
